import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Configuration } from '../configuration';
import {LoggedInUserService} from './logged.in.user';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private readonly config: Configuration, private readonly loggedInUserService: LoggedInUserService) {

    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // check if the url is to the base api
        // then check that the url isn't on the ignore token list
        var reqUrl = req.url.toLowerCase();

        var shouldIgnore = this.config.auth.nonTokenUrls.some(url => {
            return reqUrl.indexOf(url.toLowerCase()) > -1;
        });

        if (req.url.indexOf(this.config.routing.api.baseUrl) > -1 &&
            !shouldIgnore) {
            req = req.clone({
                setHeaders: {
                    'Authorization': `Bearer ${this.getToken()}`,
                    [this.config.auth.currentUserHeaderName]: this.loggedInUserService.getCurrentUser().userId.toString()
                }
            });
        }

        return next.handle(req);
    }

    private getToken(): string {
        return localStorage.getItem(this.config.auth.jwtAuthTokenStorageId);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/auth/token.interceptor.ts